import nsFormDictionary from '../../ru/ns-form/ns-form.dic.json';

export const nsFormNS = {
  NS_FORM: nsFormDictionary,
};

export const nsFormNamespaces = ['NS_FORM'];
